import { Pipe, PipeTransform } from '@angular/core';

import { NO_VALUE } from '@pipes';

import { NumberValue } from '@vi-iot/client';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateEcowaterRemainingProperty',
})
export class TranslateEcowaterRemainingPropertyPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(remaining: NumberValue): string {
    if (
      typeof remaining.value === 'number' &&
      remaining.unit &&
      this.customTranslationsService.DATE_PARTS[remaining.unit]
    ) {
      return `${remaining.value} ${this.translateService.instant(
        this.customTranslationsService.DATE_PARTS[remaining.unit] ?? remaining.unit
      )}`;
    }

    return NO_VALUE;
  }
}
